const BASE = process.env.REACT_APP_SITE_URL || "";

function clearSession() {
  localStorage.removeItem("rh-token");
  localStorage.removeItem("rh-refreshToken");
  localStorage.removeItem("authkey");
}

export default async function sessionInterceptor(response: Response) {
  if (response.status === 401) {
    clearSession();
    window.location.replace(`${BASE}/login`);
    return;
  }
}
